<script setup>
import uppercase from '@/helpers/strings/uppercase.js'
import { computed, defineAsyncComponent, ref, watch } from 'vue'

const CanvasCircle = defineAsyncComponent(() => import('@elements/Canvas/CanvasCircle.vue'))
const CanvasText = defineAsyncComponent(() => import('@elements/Canvas/CanvasText.vue'))
const CustomCanvas = defineAsyncComponent(() => import('@elements/Canvas/CustomCanvas.vue'))

const props = defineProps({
	firstName: { type: String, default: 'J' },
	lastName: { type: String, default: 'D' },
})

const bgColor = ref('white')
const fgColor = ref('black')
const redraw = ref(0)

const initials = computed(() => {
	const charFirst = uppercase(props.firstName?.charAt(0))
	const charLast = uppercase(props.lastName?.charAt(0))
	return `${charFirst}${charLast}`
})

watch(initials, () => { redraw.value++ })

/*
 const colorMatrix = [
 [ '#FFC6B2', '#FF9E81', '#FF603F', '#F52C15', '#E10000', '#C90000', '#B60000', '#A60000', '#970000', '#8B0000' ],
 [ '#FFC898', '#FFA155', '#EE7101', '#CF5E00', '#B75100', '#A34800', '#934100', '#853B00', '#783600', '#6D3100' ],
 [ '#F9CF00', '#D9B400', '#B19200', '#977D00', '#856D00', '#766102', '#6A5706', '#604F08', '#57470A', '#4F410B' ],
 [ '#7EEA7C', '#52CF58', '#39AA41', '#309137', '#2B7F30', '#28712C', '#256528', '#235B25', '#215322', '#1F4B20' ],
 [ '#63E6DD', '#24CCC3', '#00A69F', '#008E88', '#057C77', '#0B6F6A', '#0F635F', '#125A56', '#13514E', '#144A47' ],
 [ '#A5D9F9', '#6AC1F0', '#05A0D6', '#0088BA', '#0077A4', '#0077A4', '#005F84', '#005677', '#004E6C', '#044762' ],
 [ '#D6CCFF', '#BBADFD', '#9487F0', '#7B70DF', '#6A61CB', '#5E56B8', '#544DA7', '#4B4597', '#453F89', '#3F397C' ]
 ]

 const firstIndex = parseInt(charFirst, 36) % colorMatrix.length
 const secondIndex = parseInt(charLast, 36) % colorMatrix[firstIndex].length
 this.bgColor = colorMatrix[firstIndex][secondIndex]
 if (secondIndex > 4) {
 this.fgColor = 'white'
 }
 */

bgColor.value = '#eee'
fgColor.value = '#333'
</script>

<template>
	<CustomCanvas
		:height="100"
		:width="100"
		class="nfo-menu-user-avatar"
	>
		<CanvasCircle
			:order="1"
			:fill="bgColor"
			:radius="50"
			:x="50"
			:y="50"
		/>
		<CanvasText
			:order="2"
			:fill="fgColor"
			:font-size="50"
			:text="initials"
			:x="50"
			:y="55"
		/>
	</CustomCanvas>
</template>
